import { REMOVE_DUPLICATE_FIELD_ERROR, SET_DUPLICATE_FIELD_ERROR } from '../types';

export const setDuplicateError = (dispatch, id) =>
  dispatch({
    type: SET_DUPLICATE_FIELD_ERROR,
    payload: { id },
  });

export const removeDuplicateError = (dispatch, id) =>
  dispatch({
    type: REMOVE_DUPLICATE_FIELD_ERROR,
    payload: { id },
  });
